<template>
	<span>
		<b>{{timer}}</b>
	</span>
</template>

<script>
	export default {
		name: "Countdown",
		props: ["timeleft"],
		data() {
			return {
				timeHandler: null,
				timer: "",
			}
		},
		watch: {
			timeleft: function (val) {
				if (val === 0) {
					return
				}
				this.run(val)
			}
		},
		methods: {
			run(timeleft) {
				var minute;
				var second;
				
				this.timeHandler = setInterval(() => {
					timeleft = timeleft - 1;
					minute = Math.floor(timeleft / 60);
					second = timeleft % 60
					if (timeleft <= 0) {
						this.callbackCountdown()
						this.stop()
					}
					minute = (minute < 10) ? "0" + minute : minute
					second = (second < 10) ? "0" + second : second
					this.timer = minute + "." + second
				}, 1000);
			},
			stop() {
				clearInterval(this.timeHandler)
			},
			callbackCountdown() {
				this.$emit("callbackCountdown")
			}
		},
	}
</script>